import React, {useEffect, useState} from 'react'
import {TimesheetTableBody} from "./TimesheetTableBody";
import {TimesheetTableHeader} from "./TimesheetTableHeader";
import {useSelector} from 'react-redux';
import {ISelect} from "../../../../models";

interface ITimesheetTableProps {
    rowsSelectValue: any
    itemToEdit: any
}

export const TimesheetTable: React.FC<ITimesheetTableProps> = ({rowsSelectValue, itemToEdit}) => {

    const [filterByProjectName, setFilterByProjectName] = useState("")
    const [filterByProjectDescription, setFilterByProjectDescription] = useState("")
    const [sortByDate, setSortByDate] = useState("ASC")
    const [sortByTotal, setSortByTotal] = useState("")
    const [sortByHF, setSortByHF] = useState("default")
    const [sortByCategories, setSortByCategories] = useState<ISelect>({value: "default", label: "All categories"});

    return (
        <div className="section-table__main table-timesheet table-to-download-pdf">
            {/*<SimpleBar autoHide={false} className="section-table__main--container">*/}
                <div className="section-table__main--container">
                    <div className="section-table__main--wrapper">
                        <TimesheetTableHeader
                            setFilterByProjectName={setFilterByProjectName}
                            setFilterByProjectDescription={setFilterByProjectDescription}
                            setSortByDate={setSortByDate}
                            setSortByTotal={setSortByTotal}
                            setSortByHF={setSortByHF}
                            setSortByCategories={setSortByCategories}
                        />
                        <TimesheetTableBody
                            rowsSelectValue={rowsSelectValue}
                            filterByProjectName={filterByProjectName}
                            filterByProjectDescription={filterByProjectDescription}
                            sortByDate={sortByDate}
                            sortByTotal={sortByTotal}
                            sortByHF={sortByHF}
                            itemToEdit={itemToEdit}
                            sortByCategories={sortByCategories}
                        />
                    </div>
                </div>
            {/*</SimpleBar>*/}

        </div>
    )
}
